import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {createEmployee} from "../../store/employee-slice";
import {employeeSchema} from "../../schema/employeeSchema";
import {getFormData} from "../../models/employeeModel";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Form from "../../components/common/form/Form";
import {appendNested} from "../../components/Utility";

const EmployeeAdd = () => {
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const userRole = useSelector((state) => state.auth.selectedRole);
    const {
        createStatus,
        error
    } = useSelector(state => state.employee);

    useEffect(() => {
        if (createStatus === "success") {
            navigator(".."); // Adjust the navigation path as needed
        }
    }, [createStatus, navigator]);

    const formSubmitHandler = (data) => {
        const formData = new FormData();

        appendNested(formData, {
            id: userRole.scopeId,
            ...data,
        });

        /* for (const [key, value] of formData.entries()) {
             console.log(key, value);
         }*/

        dispatch(createEmployee({
            roleSign: userRole.roleSign,
            data: formData
        }));
    };

    const formCancelHandler = () => {
        navigator(".."); // Adjust the navigation path as needed
    };

    const schema = employeeSchema(); // Updated schema
    const initialData = getFormData(); // Now from employee model
    return (
        <>
            <SubHeader title="Add Employee">
                <Button to=".." className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-8">
                        <Form
                            onFormSubmit={formSubmitHandler}
                            onFormCancel={formCancelHandler}
                            schema={schema}
                            inline={false}
                            initialData={initialData}
                            status={createStatus}
                            error={error}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
export default EmployeeAdd;
